<template>
    <c-dialog ref="dialog" mode="slide" width="85vw" enable-flex mask-close>
        <module>
            <module-col size="300">
                <c-detail class="m-detail-form">
                    <c-detail-item label="采购单号">
                        {{detailData.purchase_code}}
                    </c-detail-item>
                    <c-detail-item label="采购数(台)">
                        {{detailData.purchase_count}}
                    </c-detail-item>
                    <c-detail-item label="数据统计">
                        收 {{detailData.purchase_product_count}}
                        验 {{detailData.checked_count}}
                        退 {{detailData.return_count}}
                    </c-detail-item>
                    <c-detail-item label="采购渠道">
                        <c-state tag async dict="PURCHASE_CHANNEL" :value="detailData.purchase_channel"></c-state>
                    </c-detail-item>
                    <c-detail-item label="售卖人">
                        {{detailData.seller_name}}
                    </c-detail-item>
                    <c-detail-item label="售卖人手机号">
                        {{detailData.seller_phone}}
                    </c-detail-item>
                    <c-detail-item label="售卖地址">
                        {{detailData.seller_address}}
                    </c-detail-item>
                    <c-detail-item label="快递单号">
                        {{detailData.express_no||'-'}}
                    </c-detail-item>
                    <c-detail-item label="仓库">
                        {{detailData.store_name||'-'}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date||'-'}}
                    </c-detail-item>
                </c-detail>
            </module-col>
            <module-col tab-type="border-tab">
                <c-form ref="purchaseForm">
                    <c-form link-parent>
                        <c-form-item label="采购数" required tip="请填写实际收货的商品数量">
                            <c-input name="purchase_product_count" v-model="purchase_product_count" type="number" decimal="0"
                                     :range="[1,9999]" append-text="件"></c-input>
                        </c-form-item>
                    </c-form>
                </c-form>
                <module-tab name="采购商品" enable-flex>
                    <m-operate border>
                        <c-button color="main" v-if="auth('b_online_purchase_order_edit')"
                                  prepend-icon="tf-add" @click="addRow()" :disabled="!canAddCode">添加一行
                        </c-button>
<!--                        <c-button color="main" :hollow="true" v-if="auth('b_online_purchase_order_edit')"
                                  prepend-icon="tf-search" @click="openImeiFactoryQuery()">查询IMEI出厂信息
                        </c-button>-->
                        <c-input ref="codeInput" v-model="scanCode" placeholder="请输入/扫描背贴码"
                                 @keyup.enter.native="scanHandle" :disabled="!canAddCode" style="width: 200px;">
                            <template #appendIcon><i class="tf-scan"></i></template>
                        </c-input>
                        <c-button color="main" @click="scanHandle" :disabled="!canAddCode">确定</c-button>
                        <template #right>
                            <p class="m-kb-tip" v-if="auth('b_online_purchase_order_edit')">快捷键：<span>Ctrl + Enter</span>添加一行；<span>Ctrl + Delete</span>删除光标所在行</p>
                        </template>
                    </m-operate>
                    <c-table ref="productTable" border :paging="false">
                        <c-table-column label="状态" width="65" required>
                            <template #default="{data}">
                                <span v-if="!data.id" style="color: red">待保存</span>
                                <span v-else>
                                  <!-- purchase_state 采购状态：1-待收货；2-质检中；3-待确认；4-已确认；5-待退回；6-已退回',-->
                                  <span v-if="data.purchase_state == 2" style="color: blue">质检中</span>
                                  <span v-else-if="data.purchase_state == 3" style="color: brown">待确认</span>
                                  <span v-else-if="data.purchase_state == 4" style="color: green">已确认</span>
                                  <span v-else-if="data.purchase_state == 5" style="color: red">待退回</span>
                                  <span v-else-if="data.purchase_state == 6" style="color: gray">已退回</span>
                                </span>
                            </template>
                        </c-table-column>
                        <c-table-column label="初检状态" width="80">
                            <template #default="{data}">
                                <span v-if="data.inspection_state == 2" style="color: blue">已初检</span>
                                <span v-else style="color: red">待初检</span>
                            </template>
                        </c-table-column>
                        <c-table-column label="背贴码" width="180" required>
                            <template #default="{data}">
                                <c-input type="hidden" name="inspection_state" v-model="data.inspection_state"></c-input>
                                <c-input name="produce_unique_code" v-model="data.produce_unique_code" maxlength="30"
                                         :disabled="!data.editable"
                                         @input="clearCodeError(data)"
                                         @enter="checkProductCode(data)"
                                         @change="checkProductCode(data)"></c-input>
                                <div class="m-code-error-tip" v-if="data.code_error">{{data.code_error}}</div>
                            </template>
                        </c-table-column>
                        <c-table-column label="IMEI码" width="185" required>
                            <template #default="{data}">
                                <c-input name="produce_imei" v-model="data.produce_imei" maxlength="30"
                                         :disabled="!data.editable"
                                         @input="clearImeiTip(data)"
                                         @enter="checkImei(data)"
                                         @change="checkImei(data)">
                                    <template #append>
                                        <a v-if="data.editable" class="m-gen-imei" :class="{'z-dis': data.imei_generating}"
                                           @click="generateImei(data)">生成</a>
                                    </template>
                                </c-input>
                                <div class="m-imei-tip" v-if="data.imei_tip">{{data.imei_tip}}</div>
                            </template>
                        </c-table-column>
                        <c-table-column label="类目" width="100" required>
                            <template #default="{data}">
                                <c-select name="category_id"
                                          async @search="searchCategory"
                                          @change="changeSelect($event, data,'categoryId')"
                                          :value-data="data.productCategory"
                                          v-model="data.category_id"
                                          :disabled="!data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="品牌" width="100" required>
                            <template #default="{data}">
                                <c-select name="brand_id"
                                          async @search="searchBrand(data,arguments[0], arguments[1])"
                                          @change="changeSelect($event, data,'brandId')"
                                          :value-data="data.productBrand"
                                          v-model="data.brand_id"
                                          :disabled="!data.category_id || !data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="机型" width="180" required>
                            <template #default="{data}">
                                <c-select name="spu_model_id"
                                          async @search="searchModel(data,arguments[0], arguments[1])"
                                          @change="changeSelect($event, data,'modelId')"
                                          :value-data="data.productModel"
                                          v-model="data.spu_model_id"
                                          :disabled="!data.brand_id || !data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="内存" width="100">
                            <template #default="{data}">
                                <c-select name="memory_id"
                                          async @search="searchSpuAttribute(data,'storage', arguments[0], arguments[1])"
                                          :value-data="data.productMemory"
                                          v-model="data.memory_id"
                                          :disabled="!data.spu_model_id || !data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="颜色" width="120">
                            <template #default="{data}">
                                <c-select name="color_id"
                                          async @search="searchSpuAttribute(data,'color', arguments[0], arguments[1])"
                                          :value-data="data.productColor"
                                          v-model="data.color_id"
                                          :disabled="!data.spu_model_id || !data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="等级" width="100">
                            <template #default="{data}">
                                <c-select name="level_type"
                                          async @search="searchDicInfo('LEVEL_TYPE', arguments[0], arguments[1])"
                                          :value-data="data.productLevel"
                                          v-model="data.level_type"
                                          :disabled="!data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="演示机" width="110">
                            <template #default="{data}">
                                <c-select name="is_demo" :options="yesOrNoOptions"
                                          v-model="data.is_demo"
                                          :disabled="!data.editable"
                                          :clear="false"></c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="外部订单号" width="100">
                            <template #default="{data}">
                                <c-input name="out_order_number" v-model="data.out_order_number" maxlength="30"
                                         :disabled="!data.editable"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="采购价" width="110" required>
                            <template #default="{data}">
                                <c-input name="purchase_price" v-model="data.purchase_price" type="number" decimal="2"
                                         :range="[0,999999]" placeholder="采购价" append-text="元"
                                         :disabled="!data.editable" :clear="false"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="同行价" width="110">
                            <template #default="{data}">
                                <c-input name="market_price" v-model="data.market_price" type="number" decimal="2" :range="[0,999999]"
                                         placeholder="同行价" append-text="元"
                                         :disabled="!data.editable" :clear="false"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="零售价" width="110">
                            <template #default="{data}">
                                <c-input name="retail_price" v-model="data.retail_price" type="number" decimal="2" :range="[0,999999]"
                                         placeholder="零售价" append-text="元"
                                         :disabled="!data.editable" :clear="false"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="备注" width="100">
                            <template #default="{data}">
                                <c-input name="remark" v-model="data.remark" maxlength="100"
                                         :disabled="!data.editable"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column type="button" label="操作" width="80">
                            <template #default="row">
                                <c-table-button v-if="auth('b_online_purchase_check') && row.data.editable == 1" :disabled="!purchase_order_id || !row.data.id" icon="tf-checkout" @click="$refs.productUniqueCodeCheck.open(false,row.data);">初检</c-table-button>
                                <c-table-button color="red" v-if="auth('b_online_purchase_order_edit') && row.data.editable == 1" icon="tf-trash" @click="removeRow(row);">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </module-tab>
            </module-col>
        </module>

        <template #button>
            <c-button v-if="purchase_state == 2" color="gray" size="dialog" @click="submitHandle(2)">暂存</c-button>
            <c-button color="main" size="dialog" @click="submitHandle(3)">确认</c-button>
        </template>
        <!--唯一码初检弹窗-->
        <product-unique-code-check ref="productUniqueCodeCheck" @resolve="checkResolve"></product-unique-code-check>
    </c-dialog>
</template>
<script>
import productUniqueCodeCheck from "@/pages/product/product_unique_code_check.vue";
import {mapState} from "vuex";

export default {
    name: 'onlinePurchaseEdit',
    props: {
        operation_type: [String, Number]        //操作类型 1=确认收货 2=编辑
    },
    components: {productUniqueCodeCheck},

    computed: {
		...mapState(['yesOrNoOptions']),
        //是否还允许添加背贴码
        canAddCode() {
            var productCount = 0;
            if (this.$refs.productTable){
                var product_list = this.$refs.productTable.getData();
                if (product_list && product_list.length > 0){
                    productCount = product_list.length;
                }
            }
            if (productCount >= this.purchase_product_count){
                return false;
            }
            return true;
        }
    },
    data() {
        return {
            //采购状态（1：待收货，2：质检中，3：待确认，4：已确认，5：部分入库，6：已入库，7：已取消）
            purchase_state:2,
            detailData:{},
            purchase_order_id: 0,
            purchaseDepOptions: [],//已选中的采购部门
            purchaseDeptId:0,    //采购部门
            scanCode: '',        //扫码输入的背贴码
            imiePoints: 0,       //IMEI查询积分余额
            purchase_product_count:0,//采购总数
        }
    },

    mounted() {
        //下拉框键盘操作（方向键选择、回车确认）统一在 document 监听
        document.addEventListener('keydown', this.kbKeydownHandle);
        //行内输入框回车跳转在 keyup 处理，保证输入框自身 enter 校验先执行
        document.addEventListener('keyup', this.kbKeyupHandle);
        this.kbSelect = null;
        this.kbActiveEl = null;
        this.kbActiveItem = null;
        this.kbEnterDown = false;
        this.kbCtrlEnterDown = false;
        this.kbTabAnchor = null;
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.kbKeydownHandle);
        document.removeEventListener('keyup', this.kbKeyupHandle);
    },

    methods: {
        /*************下拉框键盘操作：方向键高亮、回车确认并跳转同行下一个可编辑控件*************/
        //收集组件树内所有 c-select 实例
        collectSelects(vm, list) {
            vm.$children.forEach(child => {
                if (child.$options.name == 'cSelect') list.push(child);
                this.collectSelects(child, list);
            });
            return list;
        },

        //当前展开下拉框的 c-select 实例
        openSelect() {
            return this.collectSelects(this, []).find(item => item.listPosition !== false);
        },

        //展开下拉框中当前可见的选项 DOM（排除禁用项与“新增”项）
        kbOptionItems(select) {
            return Array.prototype.slice.call(select.$refs.list.querySelectorAll('.c-select-options-item:not([disabled]):not(.c-select-options-add), .c-select-options-custom'));
        },

        //与渲染同序的可见选项数据（异步不过滤关键字，非异步按关键字过滤，含子级递归），与 kbOptionItems 的 DOM 序一一对应
        kbVisibleOptions(select) {
            const list = [];
            const keyword = (select.searchValue || '').trim().toLowerCase();
            !function loop(items) {
                (items || []).forEach(item => {
                    if (select.asyncState || !keyword || String(item.name).toLowerCase().includes(keyword)) list.push(item);
                    loop(item.children);
                });
            }(select.optionsList);
            return list;
        },

        kbClearActive() {
            if (this.kbActiveEl) {
                this.kbActiveEl.style.background = '';
                this.kbActiveEl = null;
            }
            this.kbActiveItem = null;
        },

        /*************快捷键操作：Ctrl+Enter 添加一行、Ctrl+Delete 删除光标所在行*************/
        kbKeydownHandle(e) {
            //输入法组合期间的回车/方向键不介入（如搜狗确认候选词）
            if (e.isComposing || e.keyCode == 229) return;
            //弹窗未打开时不响应任何快捷键（弹窗为常驻单例，document 监听一直存在）
            if (!this.$refs.dialog || !this.$refs.dialog.active) return;
            //Ctrl+Enter：快捷添加一行（组合键避开普通 Enter 的行内跳转与下拉框确认）
            if (e.key == 'Enter' && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                //标记本次回车已在 keydown 处理，keyup 不再执行行内跳转
                this.kbCtrlEnterDown = true;
                this.kbAddRowHandle();
                return;
            }
            //Ctrl+Delete：快捷删除光标所在行（纯 Delete 保留输入框原生删字符行为）
            if (e.key == 'Delete' && (e.ctrlKey || e.metaKey)) {
                this.kbDeleteRowHandle(e);
                return;
            }
            //Tab 键：聚焦到下拉框时自动展开（含无搜索框、原生不可聚焦的下拉框）
            if (e.key == 'Tab') {
                this.kbTabHandle(e);
                return;
            }
            if (['ArrowDown', 'ArrowUp', 'Enter'].indexOf(e.key) == -1) return;
            const select = this.openSelect();
            if (!select) return;
            //切换下拉框后清空上一个的高亮状态
            if (this.kbSelect !== select) {
                this.kbSelect = select;
                this.kbClearActive();
            }
            const options = this.kbOptionItems(select);
            if (!options.length) return;
            e.preventDefault();
            e.stopPropagation();
            if (e.key == 'Enter') {
                //回车确认：优先用方向键高亮时记录的选项数据（避免异步重渲染导致 DOM 索引错位丢失高亮），
                //其次搜索关键字首匹配，再次空值时取首项；已有值且未高亮则保持原值收起
                let item = this.kbActiveItem;
                if (!item) {
                    const items = this.kbVisibleOptions(select);
                    if (select.searchConfig && select.searchValue.trim()) item = items[0];
                    else if (select.emptyState || !select.currentData.length) item = items[0];
                }
                this.kbClearActive();
                //走组件库自身回填链路（同 customEvent 回调）：显式写入回显对象+值并触发 change 联动，
                //不依赖 clickHandle 的“同值跳过”判断，也不依赖合成 DOM click
                if (item) {
                    if (select.multiple) {
                        select.$refs.options.clickHandle(item);
                    } else {
                        select.setValueData([item]);
                        select.changeHandle();
                    }
                }
                select.foldHandle();
                //标记本次回车已在 keydown 处理，keyup 不再重复跳转
                this.kbEnterDown = true;
                this.$nextTick(() => this.focusNextInRow(select.$el));
                return;
            }
            //方向键高亮：在可见选项 DOM 中上下移动，并同步记录对应选项数据供回车确认
            let index = this.kbActiveEl ? options.indexOf(this.kbActiveEl) : -1;
            index = e.key == 'ArrowDown' ? index + 1 : index - 1;
            index = Math.min(Math.max(index, 0), options.length - 1);
            this.kbClearActive();
            this.kbActiveEl = options[index];
            this.kbActiveEl.style.background = '#F5F5F5';
            //同步记录高亮项对应的选项数据，回车确认时直接使用，避免依赖 DOM 索引二次映射
            this.kbActiveItem = this.kbVisibleOptions(select)[index];
            this.kbActiveEl.scrollIntoView({block: 'nearest'});
        },

        //Tab 导航：下一个候选是下拉框时接管焦点并展开；普通控件仍走原生 Tab（候选集与原生可聚焦序一致）
        kbTabHandle(e) {
            const selector = 'input:not([disabled]):not([type=hidden]), textarea:not([disabled]), button:not([disabled]), .c-select:not(.z-dis)';
            const candidates = Array.prototype.slice.call(this.$el.querySelectorAll(selector))
                .filter(el => el.getClientRects().length && !(el.tagName == 'INPUT' && el.closest('.c-select')));
            if (!candidates.length) return;
            const open = this.openSelect();
            const active = document.activeElement;
            const activeSelectRoot = active && active.closest ? active.closest('.c-select') : null;
            let index = -1;
            //上次 Tab 展开的无搜索框下拉框仍开着时，以它为当前位置继续导航
            if (this.kbTabAnchor && open && open.$el === this.kbTabAnchor) {
                index = candidates.indexOf(this.kbTabAnchor);
            } else {
                this.kbTabAnchor = null;
                index = candidates.indexOf(active);
                if (index == -1 && activeSelectRoot) index = candidates.indexOf(activeSelectRoot);
            }
            const next = candidates[index + (e.shiftKey ? -1 : 1)];
            //边界或普通控件：交还浏览器原生 Tab
            if (!next || !next.classList.contains('c-select')) {
                this.kbTabAnchor = null;
                return;
            }
            e.preventDefault();
            const nextSelect = this.collectSelects(this, []).find(item => item.$el === next);
            if (!nextSelect) return;
            if (open && open !== nextSelect) open.foldHandle();
            this.kbTabAnchor = next;
            if (nextSelect.$refs.input) nextSelect.$refs.input.focus();
            else nextSelect.developHandle();
        },

        //行内输入框回车：跳转同行下一个可编辑控件（输入框自身 enter 校验已在 keyup 目标节点先触发）
        kbKeyupHandle(e) {
            if (e.isComposing || e.keyCode == 229) return;
            if (e.key != 'Enter') return;
            //Ctrl+Enter（添加一行）的回车弹起：仅消费标志，不执行行内跳转
            if (this.kbCtrlEnterDown) {
                this.kbCtrlEnterDown = false;
                return;
            }
            if (e.ctrlKey || e.metaKey) return;
            if (this.kbEnterDown) {
                this.kbEnterDown = false;
                return;
            }
            const input = e.target;
            if (!input || input.tagName != 'INPUT' || input.disabled || input.type == 'hidden') return;
            //下拉框自身搜索框的回车由 keydown 分支处理，不重复跳转
            if (input.closest('.c-select')) return;
            const row = input.closest('tr');
            if (!row || !this.$el.contains(input)) return;
            this.focusNextInRow(input);
        },

        //回车确认后跳转同行下一个可编辑控件：输入框聚焦、下拉框展开
        focusNextInRow(root) {
            const selector = 'input:not([disabled]):not([type=hidden]), .c-select:not(.z-dis)';
            let candidates = [];
            const row = root.closest('tr');
            if (row) {
                candidates = Array.prototype.slice.call(row.querySelectorAll(selector));
            } else {
                const formItem = root.closest('.c-form-item');
                const form = formItem && formItem.closest('.c-form');
                if (!form) return;
                //表单区：取同一行（offsetTop 相同）表单项内的控件为候选
                candidates = Array.prototype.slice.call(form.querySelectorAll('.c-form-item'))
                    .filter(item => item.offsetTop == formItem.offsetTop)
                    .reduce((list, item) => list.concat(Array.prototype.slice.call(item.querySelectorAll(selector))), []);
            }
            const start = candidates.indexOf(root);
            for (let i = start + 1; i < candidates.length; i++) {
                //跳过当前下拉框自身的搜索输入框
                if (root.contains(candidates[i])) continue;
                if (candidates[i].tagName == 'INPUT') {
                    candidates[i].focus();
                } else {
                    const next = this.collectSelects(this, []).find(item => item.$el === candidates[i]);
                    if (next) {
                        next.$refs.input ? next.$refs.input.focus() : next.developHandle();
                    }
                }
                return;
            }
        },

        //存在其它打开状态的弹窗（删除确认框、初检弹窗等子弹窗）时返回 true，
        //避免快捷键干扰子弹窗操作或重复弹出删除确认框
        kbHasOtherOpenDialog() {
            var dialogs = document.querySelectorAll('.c-dialog');
            for (var i = 0; i < dialogs.length; i++) {
                var dialog = dialogs[i];
                if (this.$el.contains(dialog)) continue;
                //关闭中的弹窗带 an-fadeout 动画类，完全关闭的弹窗不可见，均不算打开状态
                if (!dialog.classList.contains('an-fadeout') && dialog.getClientRects().length) return true;
            }
            return false;
        },

        //Ctrl+Enter 添加一行
        kbAddRowHandle() {
            if (this.kbHasOtherOpenDialog()) return;
            //无编辑权限时“添加一行”按钮本身不显示，快捷键同样静默返回
            if (!this.auth('b_online_purchase_order_edit')) return;
            if (!this.canAddCode) {
                this.$message({
                    message: this.purchase_product_count > 0 ? '采购商品明细数量已达采购数，不能再添加' : '请先填写采购数',
                    type: 'warn'
                });
                return;
            }
            this.addRow();
            this.focusNewRowFirstInput();
        },

        //Ctrl+Delete 删除光标所在行
        kbDeleteRowHandle(e) {
            if (this.kbHasOtherOpenDialog()) return;
            var active = document.activeElement;
            //定位光标所在的商品明细行（tbody 的 tr 与表格行数据顺序一一对应，排除展开行等附加行）
            var table = this.$refs.productTable;
            var tr = active && active.closest ? active.closest('tr') : null;
            var inProductRow = !!(table && tr && table.$el.contains(tr));
            if (active && active.tagName == 'INPUT' && !active.disabled && active.type != 'hidden') {
                //下拉框自身的搜索输入框（分类/品牌/机型等）：处于选项关键字编辑场景，保留原生删除字符行为
                if (active.closest('.c-select')) return;
                var hasSelection = false;
                try {
                    //number 等不支持选区 API 的输入框会抛异常或返回 null，按无选区处理
                    hasSelection = active.selectionStart != null && active.selectionStart != active.selectionEnd;
                } catch (err) {
                    hasSelection = false;
                }
                if (inProductRow) {
                    //行内输入框（背贴码、IMEI码、价格等）：选中了文本时保留原生删除选中文本；
                    //未选中仅光标定位时 Ctrl+Delete 直接删除整行（逐字符编辑用 Backspace/Delete）
                    if (hasSelection) return;
                } else {
                    //行外输入框（扫码框、采购数等表单项）：保留原生删除字符行为，不触发删行
                    var value = active.value || '';
                    var keepNative = false;
                    try {
                        keepNative = active.selectionStart == null ? value.length > 0
                                : (hasSelection || active.selectionStart < value.length);
                    } catch (err) {
                        keepNative = true;
                    }
                    if (keepNative) return;
                }
            }
            var row = null;
            if (inProductRow) {
                var trList = Array.prototype.filter.call(
                    table.$el.querySelectorAll('.c-table-body tbody > tr'),
                    item => !item.getAttribute('extra')
                );
                var index = Array.prototype.indexOf.call(trList, tr);
                row = index == -1 ? null : table.getRow(index);
            }
            if (!row) {
                this.$message({message: '请先将光标定位到商品明细行内，再按 Ctrl + Delete 键删除该行', type: 'warn'});
                return;
            }
            //与操作列删除按钮保持一致的删除条件
            if (!this.auth('b_online_purchase_order_edit') || row.data.editable != 1) {
                this.$message({message: '当前行不允许删除', type: 'warn'});
                return;
            }
            e.preventDefault();
            //删除完成后定位光标：被删行的下一行第一个输入框（被删行为最后一行时定位到删除后的最后一行）
            this.removeRow(row, () => this.focusRowAfterDelete(index));
        },

        //新增行后聚焦该行第一个可编辑输入框（背贴码）
        focusNewRowFirstInput() {
            this.$nextTick(() => {
                var table = this.$refs.productTable;
                if (!table || !table.$el) return;
                var trList = Array.prototype.filter.call(
                    table.$el.querySelectorAll('.c-table-body tbody > tr'),
                    item => !item.getAttribute('extra')
                );
                var tr = trList[trList.length - 1];
                if (!tr) return;
                var input = tr.querySelector('input:not([type=hidden]):not([disabled])');
                if (input) input.focus();
            });
        },

        //删除行后将光标定位到被删行的下一行第一个输入框（被删行为最后一行时定位到删除后的最后一行）
        focusRowAfterDelete(rowIndex) {
            this.$nextTick(() => {
                var table = this.$refs.productTable;
                if (!table || !table.$el) return;
                var trList = Array.prototype.filter.call(
                    table.$el.querySelectorAll('.c-table-body tbody > tr'),
                    item => !item.getAttribute('extra')
                );
                //删除后原下一行顶到被删行原索引位置
                var tr = trList[rowIndex] || trList[trList.length - 1];
                if (!tr) return;
                var input = tr.querySelector('input:not([type=hidden]):not([disabled])');
                if (input) input.focus();
            });
        },

        //打开弹窗
        open(data) {
            this.deleteProductList = [];
            this.scanCode = '';
            this.loadImiePoints();
            if (data && data.id) {
                this.purchase_order_id = data.id;
                this.getPurchaseOrderDetail();
                this.focusInput();
            }
            this.$refs.dialog.open({
                title: this.operation_type==2 ? '编辑线上采购单' : '线上采购单确认收货'
            });
        },
        /*********扫码/输入背贴码处理**********/
        scanHandle() {
            var code = this.scanCode.trim();
            if (!code) {
                this.$message({message: '请输入背贴码', type: 'warn'});
                return;
            }
            // 获取当前表格数据
            var productList = this.$refs.productTable.getData() || [];
            // 检查是否已存在
            if (productList.some(item => item.produce_unique_code == code)) {
                this.$message({message: '该背贴码已添加', type: 'warn'});
                this.scanCode = '';
                this.focusInput();
                return;
            }
            this.request({
                url: '/productCode/access/detail',
                data: {
                    produce_unique_code: code,
                    action_type: 1  //1=背贴码绑定商品
                },
                loading: true,
                success: data => {
                    if (data.main_state != 1) {
                        this.$message({message: '当前商品主状态非【待绑定】，无法添加', type: 'warn'});
                        this.scanCode = '';
                        this.focusInput();
                        return;
                    }
                    if (data.purchase_order_id && data.purchase_order_id!= this.purchase_order_id) {
                        this.$message({message: '当前背贴码已关联其他采购单，无法添加', type: 'warn'});
                        this.scanCode = '';
                        this.focusInput();
                        return;
                    }
                    // 构建行数据
                    var rowData = {};
                    rowData.editable = 1;
                    rowData.code_checked = data.produce_unique_code || code;//已通过接口校验的背贴码
                    rowData.produce_unique_code = data.produce_unique_code || code;
                    rowData.produce_imei = data.produce_imei || '';
                    rowData.category_id = data.category_id || '';
                    rowData.brand_id = data.brand_id || '';
                    rowData.spu_model_id = data.spu_model_id || '';
                    rowData.memory_id = data.memory_id || '';
                    rowData.color_id = data.color_id || '';
                    rowData.level_type = data.level_type || '';
                    rowData.is_demo = data.is_demo || 2;//是否演示机（1-是 2-否）
                    rowData.out_order_number = data.out_order_number || '';
                    rowData.purchase_price = data.purchase_price || undefined;
                    rowData.market_price = data.market_price || undefined;
                    rowData.retail_price = data.retail_price || undefined;
                    rowData.inspection_state = 1;
                    rowData.remark = data.remark || '';
                    // 下拉选项回显
                    rowData.productCategory = data.category_name ? [{name: data.category_name, value: data.category_id}] : [];
                    rowData.productBrand = data.brand_name ? [{name: data.brand_name, value: data.brand_id}] : [];
                    rowData.productModel = data.spu_model_name ? [{name: data.spu_model_name, value: data.spu_model_id}] : [];
                    rowData.productMemory = data.memory_name ? [{name: data.memory_name, value: data.memory_id}] : [];
                    rowData.productColor = data.color_name ? [{name: data.color_name, value: data.color_id}] : [];
                    rowData.productLevel = data.level_name ? [{name: data.level_name, value: data.level_type}] : [];
                    this.$refs.productTable.push(rowData);
                    //扫码带出的IMEI码同步查重提示（仅提示不拦截）
                    this.checkImei(rowData);
                    this.scanCode = '';
                    this.focusInput();
                },
                fail: (code, obj, message) => {
                    this.$message({message: message || '背贴码校验失败，请检查', type: 'warn'});
                    this.scanCode = '';
                    this.focusInput();
                    return false;//已自行提示，不再触发全局弹窗
                }
            });
        },
        /*********清除行内背贴码校验错误提示**********/
        clearCodeError(rowData) {
            if (rowData.code_error) {
                this.$set(rowData, 'code_error', '');
            }
        },
        /*********行内背贴码校验（编辑时直接调用后端接口）**********/
        checkProductCode(rowData) {
            var code = (rowData.produce_unique_code || '').trim();
            if (!rowData.editable) {
                return;
            }
            //正在校验中或已校验通过且值未变化时，不重复请求
            if (rowData.code_checking || (code && rowData.code_checked === code)) {
                return;
            }
            this.$set(rowData, 'code_error', '');
            if (!code) {
                return;
            }
            //本地查重：与商品列表中其他行重复
            var productList = this.$refs.productTable.getData() || [];
            if (productList.filter(item => (item.produce_unique_code || '').trim() == code).length > 1) {
                this.$set(rowData, 'code_error', '该背贴码已存在于商品列表中');
                return;
            }
            this.$set(rowData, 'code_checking', true);
            this.request({
                url: '/productCode/access/detail',
                data: {
                    produce_unique_code: code,
                    action_type: 1  //1=背贴码绑定商品
                },
                success: data => {
                    if (data.main_state != 1 && data.main_state != 2) {
                        this.$set(rowData, 'code_error', '当前商品主状态非【待绑定】，无法添加');
                        return;
                    }
                    if (data.purchase_order_id && data.purchase_order_id!= this.purchase_order_id) {
                        this.$set(rowData, 'code_error', '当前背贴码已关联其他采购单，无法添加');
                        return;
                    }
                    //校验通过，记录已校验的值，避免重复请求
                    this.$set(rowData, 'code_checked', code);
                    this.$set(rowData, 'code_error', '');
                },
                fail: (code, obj, message) => {
                    //错误显示在行内输入框下方，不再触发全局弹窗
                    this.$set(rowData, 'code_error', message || '背贴码校验失败，请检查');
                    return false;
                },
                complete: () => {
                    this.$set(rowData, 'code_checking', false);
                }
            });
        },
        /*********清除行内IMEI码提示（c-input聚焦时也会补发input事件，故仅值真实变化时才清除，避免点击输入框提示消失）**********/
        clearImeiTip(rowData) {
            if (rowData.imei_tip && (rowData.produce_imei || '').trim() !== rowData.imei_checked) {
                this.$set(rowData, 'imei_tip', '');
            }
        },
        /*********行内IMEI码查重（仅提示不拦截：列表内重复/被其他商品占用统一在输入框下方提示重新入库）**********/
        checkImei(rowData) {
            var imei = (rowData.produce_imei || '').trim();
            if (!rowData.editable) {
                return;
            }
            //已校验过且值未变化时，不重复请求
            if (rowData.imei_checking || (imei && rowData.imei_checked === imei)) {
                return;
            }
            this.$set(rowData, 'imei_tip', '');
            if (!imei) {
                return;
            }
            //本地查重：与商品列表中其他行重复，提示显示在输入框下方，不拦截入库
            var productList = this.$refs.productTable.getData() || [];
            if (productList.filter(item => (item.produce_imei || '').trim() == imei).length > 1) {
                this.$set(rowData, 'imei_checked', imei);
                this.$set(rowData, 'imei_tip', '本次为重新入库，请核对');
                return;
            }
            this.$set(rowData, 'imei_checking', true);
            this.request({
                url: '/productCode/queryByImei',
                data: {
                    produce_imei: imei,
                    produce_unique_code: (rowData.produce_unique_code || '').trim()
                },
                success: data => {
                    this.$set(rowData, 'imei_checked', imei);
                    //IMEI已被其他商品占用：后端返回提示文案（在库/重新入库），显示在输入框下方，不弹窗不拦截
                    if (data) {
                        this.$set(rowData, 'imei_tip', data);
                    }
                },
                complete: () => {
                    this.$set(rowData, 'imei_checking', false);
                }
            });
        },
        /*********背贴码输入框聚焦**********/
        focusInput() {
            this.$nextTick(() => {
                if (this.$refs.codeInput) {
                    this.$refs.codeInput.focus();
                }
            });
        },
        /*********加载当前商户IMEI查询积分余额**********/
        loadImiePoints() {
            this.request({
                url: '/sys_saas/account/info',
                success: data => {
                    if (data) {
                        this.imiePoints = data.imie_points || 0;
                    }
                }
            });
        },
        /*********生成IMEI码并回填当前行**********/
        generateImei(rowData) {
            if (rowData.imei_generating) {
                return;
            }
            this.$set(rowData, 'imei_generating', true);
            this.request({
                url: '/imei/generate',
                loading: true,
                success: data => {
                    this.$set(rowData, 'produce_imei', data);
                },
                complete: () => {
                    this.$set(rowData, 'imei_generating', false);
                }
            });
        },
        /*********打开IMEI出厂信息查询弹窗**********/
        openImeiFactoryQuery() {
            this.$message({
                message: '功能开发中'
            });
            /*var refresh = () => {
                this.loadImiePoints();
            };
            this.globalDialog('imeiFactoryQueryDialog', {}, refresh, refresh);*/
        },

        /**************变更 下拉框数据******************/
        changeSelect(selectData, rowData, type) {
            if (type == 'categoryId') {
                if (selectData) {
                    rowData.productBrand = [];
                    rowData.productModel = [];
                    rowData.productMemory = [];
                    rowData.productLevel = [];

                    rowData.brand_id = '';
                    rowData.spu_model_id = '';//型号
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            } else if (type == 'brandId') {
                if (selectData) {
                    rowData.productModel = [];
                    rowData.productMemory = [];
                    rowData.productLevel = [];

                    rowData.spu_model_id = '';//型号
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            } else if (type == 'modelId') {
                if (selectData) {
                    rowData.productMemory = [];
                    rowData.productLevel = [];
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            }
        },

        /*******搜索分类*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索品牌****************/
        searchBrand(data, keyword, resolve) {
            this.request({
                url: '/spu/brand/options',
                data: {
                    category_id: data.category_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索机型****************/
        searchModel(data, keyword, resolve) {
            this.request({
                url: '/spu/model/options',
                data: {
                    category_id: data.category_id,
                    brand_id: data.brand_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索参数信息****************/
        searchSpuAttribute(rowData, attribute_code, keyword, resolve) {
            this.request({
                url: '/spu/attribute/value/options',
                data: {
                    attribute_code: attribute_code,
                    model_id: rowData.spu_model_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索参数信息****************/
        searchDicInfo(dic_type_code, keyword, resolve) {
            this.request({
                url: '/dic/info/options',
                data: {
                    dic_type_code: dic_type_code,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索采购订单详情*******************/
        getPurchaseOrderDetail() {
            this.request({
                url: '/purchase/order/detail',
                data: {
                    purchase_order_id: this.purchase_order_id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.purchase_state = this.detailData.purchase_state;
                    this.purchase_product_count = this.detailData.purchase_product_count?this.detailData.purchase_product_count:this.detailData.purchase_count;
                    //加载工单列表
                    var productList = data.productList || [];
                    productList.forEach(item => {
                        if (!item.is_demo) item.is_demo = 2;//存量数据无该字段，默认非演示机
                    });
                    this.$refs.productTable.setData(productList);
                }
            });
        },

        /**
         * 初检完成后：刷新本弹窗采购单详情，并通知打开本弹窗的外层列表刷新
         */
        checkResolve() {
            this.getPurchaseOrderDetail();
            this.$emit('resolve');
        },

        /******添加行数据*********/
        addRow() {
            var rowData = {};
            rowData.editable = 1;//允许编辑
            rowData.produce_unique_code = '';//背贴码
            rowData.produce_imei = '';//商品国际移动设备识别码(唯一)
            rowData.category_id = '';//分类ID
            rowData.brand_id = '';//品牌ID
            rowData.spu_model_id = '';//机型ID
            rowData.memory_id = '';//内存ID
            rowData.color_id = '';//颜色ID
            rowData.level_type = '';      //等级ID
            rowData.is_demo = 2;          //是否演示机（1-是 2-否）
            rowData.out_order_number = '';//外部订单号
            rowData.purchase_price = undefined;//采购单价
            rowData.market_price = undefined;//同行价（元）
            rowData.retail_price = undefined;//零售价（元）
            rowData.inspection_state = 1;//初检状态（1：待完善，2：已完善）
            rowData.remark = '';//备注
            //下拉选项回显对象初始化（与扫码添加 scanHandle 保持一致）：
            //避免值对象未初始化导致 value-data 非响应式，进而出现键盘选中后不回显/联动异常
            rowData.productCategory = [];
            rowData.productBrand = [];
            rowData.productModel = [];
            rowData.productMemory = [];
            rowData.productColor = [];
            rowData.productLevel = [];
            this.$refs.productTable.push(rowData)
        },
        /******删除行数据*********/
        removeRow(row, removedCallback) {
            if (row.data.id) {
                this.$confirm({
                    type: 'warn',
                    message: (row.data.produce_unique_code ? '是否确认删除背贴码【' + row.data.produce_unique_code + '】' : '是否确认删除选中数据行'),
                    buttonName: '确认删除',
                    resolve: () => {
                        row.remove();
                        removedCallback && removedCallback();
                    }
                });
            } else {
                row.remove();
                removedCallback && removedCallback();
            }
        },
        /*******提交编辑数据********************/
        submitHandle(purchase_state) {
            var flag = true;
            //产品工单列表
            var product_list = this.$refs.productTable.getData();
            if (product_list.length == 0) {
                this.$message({
                    message: '请至少添加一件采购商品',
                    type: 'warn'
                });
                flag = false;
                return;
            }
            //背贴码正在校验中
            if (product_list.some(item => item.code_checking)) {
                this.$message({
                    message: '背贴码正在校验中，请稍候',
                    type: 'warn'
                });
                flag = false;
                return;
            }
            //存在校验未通过的背贴码
            if (product_list.some(item => item.code_error)) {
                this.$message({
                    message: '存在校验未通过的背贴码，请修正后重试',
                    type: 'warn'
                });
                flag = false;
                return;
            }
            product_list.forEach(item => {
                if (!item.produce_unique_code || !item.produce_imei
                        || !item.category_id || !item.brand_id || !item.spu_model_id
                        || !item.purchase_price) {
                    this.$message({
                        message: '请完善采购商品必填项',
                        type: 'warn'
                    });
                    flag = false;
                    return;
                }
            });
            //IMEI码重复仅在录入时弹窗提示，不拦截提交
            if (purchase_state == 3){
                /*product_list.forEach(item => {
                    if (item.inspection_state != 2) {
                        this.$message({
                            message: '所有商品完成初检后才能确认线上采购单',
                            type: 'warn'
                        });
                        flag = false;
                        return;
                    }
                });*/
                if ( this.purchase_product_count != product_list.length){
                    this.$message({
                        message: '采购数必须与采购商品明细行数一致',
                        type: 'warn'
                    });
                    flag = false;
                    return;
                }
            }
            if (flag){
                this.request({
                    url: this.operation_type == 1 ? '/online/purchase/order/receipt' : '/online/purchase/order/edit',
                    data: {
                        purchase_state:purchase_state,
                        purchase_product_count:this.purchase_product_count,
                        purchase_order_id: this.purchase_order_id,
                        product_list:product_list.map(item => {
                            if(!item.market_price || item.market_price == ''){
                                item.market_price = undefined;
                            }
                            if(!item.retail_price || item.retail_price == ''){
                                item.retail_price = undefined;
                            }
                            //移除背贴码校验的辅助字段
                            delete item.code_error;
                            delete item.code_checked;
                            delete item.code_checking;
                            delete item.imei_generating;
                            //移除IMEI码查重提示的辅助字段
                            delete item.imei_tip;
                            delete item.imei_checked;
                            delete item.imei_checking;
                            return item;
                        })
                    },
                    success: data => {
                        this.$message({
                            type: 'success',
                            message: this.operation_type == 1 ? '线上采购单确认收货成功' : '编辑线上采购单成功',
                        });
                        //刷新页面
                        this.$emit('resolve');
                        if (purchase_state != 2 ){
                            this.$refs.dialog.close();
                        }else {
                            //刷新页面数据
                            this.purchase_order_id = data;
                            this.getPurchaseOrderDetail();
                        }
                    }
                })
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .m-kb-tip
        font-size 12px
        line-height 20px
        color #999
        span
            padding 0 5px
            margin 0 2px
            border 1px solid #ddd
            border-radius 3px
            background #fff
            color #666
            font-weight bold
            white-space nowrap

    .m-balance-text
        margin-left 10px
        color #666
        font-size 12px

    .m-code-error-tip
        margin-top 2px
        color red
        font-size 12px
        line-height 16px
        word-break break-all
        white-space normal
        word-break break-all
        overflow-wrap break-word

    .m-imei-tip
        margin-top 2px
        color #ff8800
        font-size 12px
        line-height 16px
        white-space normal
        word-break break-all
        overflow-wrap break-word

    .m-gen-imei
        padding 0 6px
        font-size 12px
        color var(--color-main)
        line-height 30px
        white-space nowrap
        cursor pointer
        &.z-dis
            color #999
            cursor not-allowed
</style>